import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import type { BlockType } from "../../../domain/types";
import type { SnippetId } from "../../../domain/snippets";
import { BLOCK_PALETTE_ICONS } from "./blockPaletteIcons";

const FA_STROKE = 1.25;
const FA_STROKE_ROUND = "round" as const;

function PaletteFaSvg({ children }: { children: React.ReactNode }) {
  return (
    <svg
      className={classNames("builder-toolbar-palette-item-icon", "email-builder-palette-glyph-fa-icon")}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

function EyebrowPaletteGlyph() {
  return (
    <PaletteFaSvg>
      <line
        x1="1"
        y1="10"
        x2="5.5"
        y2="10"
        strokeWidth={FA_STROKE}
        strokeLinecap={FA_STROKE_ROUND}
      />
      <line
        x1="7.5"
        y1="10"
        x2="19"
        y2="10"
        strokeWidth={FA_STROKE}
        strokeLinecap={FA_STROKE_ROUND}
      />
    </PaletteFaSvg>
  );
}

function ButtonRowPaletteGlyph() {
  return (
    <PaletteFaSvg>
      <rect
        x="1"
        y="7.75"
        width="7.25"
        height="4.5"
        rx="1.25"
        strokeWidth={FA_STROKE}
      />
      <rect
        x="11.75"
        y="7.75"
        width="7.25"
        height="4.5"
        rx="1.25"
        strokeWidth={FA_STROKE}
      />
    </PaletteFaSvg>
  );
}

export function BlockPaletteGlyph({ type }: { type: BlockType }) {
  if (type === "eyebrow") {
    return <EyebrowPaletteGlyph />;
  }

  if (type === "buttonRow") {
    return <ButtonRowPaletteGlyph />;
  }

  return (
    <FontAwesomeIcon
      className="builder-toolbar-palette-item-icon"
      icon={BLOCK_PALETTE_ICONS[type]}
      aria-hidden="true"
    />
  );
}

function SectionFrame({ children }: { children: React.ReactNode }) {
  return <span className={"email-builder-palette-glyph-section-frame"}>{children}</span>;
}

export function SectionPalettePreview({ snippetId }: { snippetId: SnippetId }) {
  return (
    <span className={"email-builder-palette-glyph-preview-slot"} aria-hidden="true">
      {snippetId === "header" ? (
        <SectionFrame>
          <span className={"email-builder-palette-glyph-header-logo-bone"} />
        </SectionFrame>
      ) : null}
      {snippetId === "footer" ? (
        <SectionFrame>
          <span className={"email-builder-palette-glyph-footer-lines"}>
            <span className={"email-builder-palette-glyph-bone"} data-width="short" />
            <span className={"email-builder-palette-glyph-bone"} data-width="emphasis" />
            <span className={"email-builder-palette-glyph-bone"} data-width="medium" />
            <span className={"email-builder-palette-glyph-bone"} data-width="short" />
          </span>
        </SectionFrame>
      ) : null}
    </span>
  );
}
